import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxChartComponent } from 'devextreme-angular';
import { UtilityService } from 'src/app/core/utility.service';
import { Dashboard } from '../dashboard.models';

@Component({
  selector: 'app-orders-by-delivery-status',
  templateUrl: './orders-by-delivery-status.component.html',
  styleUrls: ['./orders-by-delivery-status.component.scss']
})
export class OrdersByDeliveryStatusComponent implements OnInit {
  @ViewChild('chart') chart: DxChartComponent;
  @Input('dashboardData') dashboardData: Dashboard;

  constructor(private utilityService: UtilityService, private translateService: TranslateService) { }

  ngOnInit(): void {
    this.dashboardData.data.sources = [
      { value: "orders", name: "DASHBOARD.NUMBER_OF_ORDERS", visible: true, icon: 'shopping_cart', color: '#1db2f5', class: 'order-count', boxClass: 'order-count-box' },
      { value: "ordersValue", name: "DASHBOARD.ORDER_VALUE", visible: false, icon: 'payment', color: '#97c95c',  class: 'order-value', boxClass: 'order-value-box' }
    ];
    for (let value of this.dashboardData.data.values) {
      if (value.date.toString().includes('T'))
        value.date = this.utilityService.formatDate(new Date(value.date));
    }
  }

  ngOnChanges(changes): void {
    if (changes != null && changes.dashboardData != null && changes.dashboardData.currentValue != null) {
      this.ngOnInit();
    }
  }

  customizeTooltip = (arg: any) => {
    return {
      text: arg.argumentText + " - " + arg.value + (arg.argumentText == 'Iznos narudžbi' ? 'KM' : '')
    };
  }

  pointClick(e: any) {
    e.target.select();
  }

  toggleChartLine(source) {
    let index = this.dashboardData.data.sources.findIndex(s => s.value == source.value);
    if (index > -1)
      this.dashboardData.data.sources[index].visible = !this.dashboardData.data.sources[index].visible;
  }

  legendClick(e: any) {
    // let series = e.target;
    // let index = this.dashboardData.data.sources.findIndex(s => s.name == series.name);
    // if (index > -1)
    //   this.dashboardData.data.sources[index].visible = !this.dashboardData.data.sources[index].visible;

    let series = e.target;
    if (series.isVisible()) {
      series.hide();
    } else {
      series.show();
    }
  }

  customizeText = (event) => {
    return this.translateService.instant('ENUMS.DELIVERY_STATUSES.' + event.valueText);
  }
}
